import { render, staticRenderFns } from "./RecordTable.vue?vue&type=template&id=ff595538&scoped=true&"
import script from "./RecordTable.vue?vue&type=script&lang=ts&"
export * from "./RecordTable.vue?vue&type=script&lang=ts&"
import style0 from "./RecordTable.vue?vue&type=style&index=0&id=ff595538&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff595538",
  null
  
)

export default component.exports